import React from 'react'
import "./missionVision.css";
function Missio() {
    return (
        <div> <section className="mission-vision ">
            <div className="container">
                <div className="section-title">
                    <h2>Our Mission & Vision</h2>
                    <p>Guiding principles that drive our business</p>
                </div>
                <div className="mission-vision-container">
                    <div className="mission-box">
                        <i className="fas fa-bullseye"></i>
                        <h3>Our Mission</h3>
                        <p>
                            To provide safe, reliable, and comfortable travel services at affordable prices,
                            exceeding customer expectations with innovation and care.
                        </p>
                    </div>
                    <div className="vision-box">
                        <i className="fas fa-eye"></i>
                        <h3>Our Vision</h3>
                        <p>
                            To become the leading tour and travel service provider known for excellence and
                            customer satisfaction, expanding our services globally while staying true to our values.
                        </p>
                    </div>
                </div>
            </div>
        </section></div>
    )
}

export default Missio